import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { Switch, Modal, ModalTitle, ModalContent } from 'src/components/core';
import { Cross } from 'src/components/core/icons';
import { FlexContainer } from 'src/components/core/layout/FlexContainer';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { setOrderSetting } from 'src/setup/redux/slices/spotSlice';

interface PreferencesModalProps {
    isOpen: boolean;
    handleClose: () => void;
}

const StyledModal = styled(Modal)`
    ${({ theme: { typography, isMobile } }) => `
        .modal-paper {
            width: ${isMobile ? '343px' : '447px'};;
            border-radius: 10px;
            .modal-title {
                padding: ${isMobile ? '16px' : '24px'};
                line-height: ${
                    isMobile
                        ? `${typography.lineHeight[4]}`
                        : `calc(${typography.lineHeight[7]} - 1px)`
                };
            }
        }
        .modal-content {
            padding: ${isMobile ? '14px 16px 16px' : '6px 24px 24px'};
        }
        .setting-item {
            justify-content: space-between;
            align-items: center;
            ${isMobile ? `gap: 25px;` : ''}
        }
    `}
`;

const LabelText = styled.div`
    ${({ theme: { typography, colors } }) => `
        font-size: ${typography.size.desktop.paragraph.p2};
        line-height: calc(${typography.lineHeight[3]} - 0.5px);
        color: ${colors.text.secondary}
    `}
`;

const PreferencesModal: FC<PreferencesModalProps> = ({ isOpen, handleClose }) => {
    const { t } = useTranslation();
    const { colors } = useTheme();
    const dispatch = useAppDispatch();
    const { isConfirm } = useAppSelector((state) => state.spot.orderSetting);

    const handleSettingChange = (value: boolean) => {
        dispatch(
            setOrderSetting({
                is_confirm: value,
            }),
        );
    };

    return (
        <>
            <StyledModal open={isOpen} size={'sm'}>
                <ModalTitle>
                    {t('trading_preferences')}
                    <Cross
                        fill={colors.text.primary}
                        onClick={handleClose}
                        style={{ height: 20, width: 20 }}
                        className={'clickable'}
                    />
                </ModalTitle>
                <ModalContent>
                    <FlexContainer className="setting-item">
                        <LabelText>{t('confirmation_required_place_orders')}</LabelText>

                        <Switch
                            value={isConfirm}
                            name="is_confirm"
                            onChange={handleSettingChange}
                        />
                    </FlexContainer>
                </ModalContent>
            </StyledModal>
        </>
    );
};

export { PreferencesModal };
